import { Navigate, useNavigate } from 'react-router-dom';
import { paths } from './paths';
import { FC, ReactElement, Suspense, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import useUserStore from '@/store/useUserStore';
import Sidebar from '@/components/layout/Sidebar';
import ResponsiveLayout from '@/components/layout/ResponsiveLayout';
import httpClient from '@/api/httpClient';
import { UserRole } from '@/api/user/user.model';

const ProtectedRoute: FC<{ children: ReactElement; useLayout?: boolean; adminOnly?: boolean }> = ({
  children,
  useLayout = true,
  adminOnly = false,
}) => {
  const { token, user } = useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    httpClient.setupResponseInterceptor(navigate);
  }, []);

  if (!token) {
    return <Navigate to={paths.LOGIN} replace />;
  }

  if (adminOnly && user?.role !== UserRole.ADMIN) {
    return <Navigate to={paths.DASHBOARD} replace />;
  }

  if (useLayout) {
    return (
      <ResponsiveLayout>
        <div className="flex min-h-screen max-w-[1920px] mx-auto">
          <Sidebar />
          <Suspense fallback={<Layout isLoading />}>
            <Layout>{children}</Layout>
          </Suspense>
        </div>
      </ResponsiveLayout>
    );
  }

  return children;
};

export default ProtectedRoute;
